export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Nome",
    lastname: "Cognome",
    email: "Indirizzo email",
    idNumber: "Numero documento",
    phone: "Telefono",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Fatture di pagamento",
    subtitle: "Elenco dei pagamenti effettuati dagli utenti",
    emailUser: "Email utente",
    value: "Importo",
    issueDate: "Data di emissione",
    status: "Stato",
    downloadInvoice: "Scarica fattura",
    generatingInvoice: "Generazione della fattura ...",
    almostDone: "Quasi fatto, attendere ...",
    loading: "Caricamento ...",
    invoiceError: "Spiacenti, non è stato possibile generare la fattura",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Consulenti della piattaforma",
    subtitle: "Elenco dei consulenti.",
    createNew: "Crea nuovo",
    thId: "ID",
    thRefCode: "Cod. rif.",
    thEmail: "Email",
    thRegisterDate: "Data di registrazione",
    deleteConfirmMsg: "Sei sicuro di voler eliminare questo consulente?",
    deleteConfirmHeader: "Conferma",
    menuUpdateInfo: "Aggiorna informazioni",
    menuAffiliatesList: "Elenco affiliati",
    menuDelete: "Elimina",
    createTitle: "Crea nuovo consulente",
    savingInfo: "Salvataggio delle informazioni...",
    saveAdvisor: "Salva consulente",
    updateTitle: "Aggiorna i dati del consulente",
    updatingInfo: "Aggiornamento delle informazioni...",
    updateAdvisor: "Aggiorna consulente",
    cancel: "Annulla",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Elenco affiliati",
    emptyPre: "Nessun utente è affiliato al codice",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Check-in completati",
    checkinsPending: "Check-in in sospeso",
    checkinsScheduled: "Check-in programmati",
    logoAndName: "Logo e nome dell'alloggio",
    welcomeMessage: "Messaggio di benvenuto",
    policies: "Politiche dell'alloggio",
    roomKeys: "Chiavi delle camere",
    authorities: "Autorità",
    guestReviews: "Recensioni degli ospiti",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Data di creazione",
    checkins: "Check-in",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Pannello di amministrazione",
    subtitle: "Elenco delle statistiche della piattaforma",
    registeredUsers: "Utenti registrati",
    viewList: "Visualizza elenco",
    propertiesCreated: "Strutture create",
    checkinsDone: "Check-in completati",
  },
};
